"use client";
import { Column, ColumnDef } from "@tanstack/react-table";
import { ArrowUpDown } from "lucide-react";
import { Ticket } from "@dripit/types";

import { Button } from "@/components/ui/button";
import React from "react";

const OrderByButton = ({
  column,
  children,
}: {
  column: Column<Ticket, unknown>;
  children: React.ReactNode;
}) => (
  <Button
    variant="ghost"
    className="px-0 py-0 hover:bg-transparent"
    onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}>
    {children}
    <ArrowUpDown className="!size-3" />
  </Button>
);

export const enum TicketsColumnKey {
  Select = "select",
  Amount = "amount",
  MintedAt = "minted_at",
  ExpirationDate = "expiration_date",
  Status = "status",
}

export const TicketsTableColumns: (ColumnDef<Ticket> & {
  accessorKey: TicketsColumnKey;
})[] = [
  {
    accessorKey: TicketsColumnKey.Amount,
    header: ({ column }) => (
      <OrderByButton column={column}>Amount</OrderByButton>
    ),
  },
  {
    accessorKey: TicketsColumnKey.MintedAt,
    header: ({ column }) => (
      <OrderByButton column={column}>Claimed at</OrderByButton>
    ),
  },
  {
    accessorKey: TicketsColumnKey.ExpirationDate,
    header: ({ column }) => (
      <OrderByButton column={column}>Expires at</OrderByButton>
    ),
  },
  {
    accessorKey: TicketsColumnKey.Status,
    header: "Status",
  },
];
